// Whether the logged-in user can use the AI assistant, and if not, why. The
// chat page, the sidebar and the dashboard all ask, so they cannot disagree
// about it.

export const AI_DISABLED_ORGANISATION = 'organisation';
export const AI_DISABLED_ACCOUNT = 'account';

// The AI assistant comes with the partner programme; a page that says the
// assistant is not active points here. The website translates its slugs
// (`_url` in website-str), and Dutch, its default language, has no prefix.
const PARTNER_PROGRAM_URLS = {
  nl: 'https://stramigo.com/partnerprogramma/',
  en: 'https://stramigo.com/en/partner-program/',
  de: 'https://stramigo.com/de/partnerprogramm/',
  fr: 'https://stramigo.com/fr/programme-partenaires/',
};

/**
 * @param {string|undefined} locale the interface language
 * @returns {string} the partner programme page in that language, Dutch when
 *   the website has no page for it.
 */
export const getPartnerProgramUrl = (locale) => (
  PARTNER_PROGRAM_URLS[locale] || PARTNER_PROGRAM_URLS.nl
);

/**
 * @param {object|null} user store.state.user
 * @returns {string|null} AI_DISABLED_ORGANISATION when the organisation has no
 *   active assistant, AI_DISABLED_ACCOUNT when it has one but AI is off for the
 *   user's membership, and null when the user can chat.
 */
export const getAiDisabledReason = (user) => {
  const organisation = user?.org;
  if (!organisation?.active_assistant) {
    return AI_DISABLED_ORGANISATION;
  }
  if (!organisation.membership?.ai_enabled) {
    return AI_DISABLED_ACCOUNT;
  }
  return null;
};
